var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useMemo } from 'react';
import MaskedInput from 'react-text-mask';
var BASE_HOUR_MINUTE_MASK_SEGMENTS = Object.freeze([/\d/, ':', /(0|1|2|3|4|5)/, /\d/]);
var SECOND_MASK_SEGMENTS = Object.freeze([':', /(0|1|2|3|4|5)/, /\d/]);
var PERIOD_MASK_SEGMENTS = Object.freeze([' ', /(A|P)/i, 'M']);
var pipe = function (conformedValue) { return conformedValue.toUpperCase(); };
export var DateTimeMaskedInput = forwardRef(function (_a, ref) {
    var use12HourClock = _a.use12HourClock, withSeconds = _a.withSeconds, restProps = __rest(_a, ["use12HourClock", "withSeconds"]);
    var mask = useMemo(function () {
        var result = [/\d/, /\d/, /\d/, /\d/, '-', /(0|1)/, /\d/, '-', /(0|1|2|3)/, /\d/, ' '];
        result.push(use12HourClock ? /(0|1)/ : /(0|1|2)/);
        BASE_HOUR_MINUTE_MASK_SEGMENTS.forEach(function (segment) { return result.push(segment); });
        if (withSeconds)
            SECOND_MASK_SEGMENTS.forEach(function (segment) { return result.push(segment); });
        if (use12HourClock)
            PERIOD_MASK_SEGMENTS.forEach(function (segment) { return result.push(segment); });
        return result;
    }, [use12HourClock, withSeconds]);
    return (_jsx(MaskedInput, __assign({}, restProps, { mask: mask, pipe: pipe, ref: function (obj) {
            var el = (obj === null || obj === void 0 ? void 0 : obj.inputElement) || null;
            if (typeof ref === 'function') {
                ref(el);
            }
            else if (ref) {
                ref.current = el;
            }
        } })));
});
DateTimeMaskedInput.displayName = 'DateTimeMaskedInput';
